import type { ConfirmationModalProps } from '@shared/components';

import { PublishQuestionModal } from '../../components';

type PublishSingleQuestionModalProps = Pick<
  ConfirmationModalProps,
  'onClose' | 'open' | 'onAccept'
>;

export default function PublishSingleQuestionModal(
  props: Readonly<PublishSingleQuestionModalProps>,
) {
  const { open: isOpen, onClose, onAccept } = props;

  return <PublishQuestionModal open={isOpen} onClose={onClose} onAccept={onAccept} />;
}
